export const generateAndSetFavicon = () => {
  const canvas = document.createElement('canvas');
  canvas.width = 32;
  canvas.height = 32;
  
  const ctx = canvas.getContext('2d');
  if (!ctx) return;
  
  ctx.fillStyle = '#e53e3e';
  ctx.fillRect(0, 0, 32, 32);
  
  ctx.strokeStyle = '#ffffff';
  ctx.lineWidth = 0.01;
  ctx.strokeRect(2, 2, 28, 28);
  
  ctx.fillStyle = '#ffffffff';
  ctx.font = 'bold 20px Arial';
  ctx.textAlign = 'center';
  ctx.textBaseline = 'middle';
  ctx.fillText('测', 16, 16);
  
  const dataUrl = canvas.toDataURL('image/png');
  
  const link = document.createElement('link');
  link.rel = 'icon';
  link.type = 'image/png';
  link.href = dataUrl;
  
  const oldFavicon = document.querySelector('link[rel="icon"]');
  if (oldFavicon && oldFavicon.parentNode) {
    oldFavicon.parentNode.removeChild(oldFavicon);
  }
  
  document.head.appendChild(link);
};
